<div class="content-container">
  <mat-form-field appearance="outline" class="form-field text-right">
    <mat-label>{{label1}}</mat-label>
    <input matInput type="number" (keypress)="integerOnly($event)" autoComplete="off" [ngModel]="baseDimension?.box?.height" (ngModelChange)="baseDimension.box.height = $event">
  </mat-form-field>
</div>